module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mv4-l mv2"
  }), _vm._v(" "), _c('div', {
    staticClass: "mr3-ns flex-grow flex-basis-2 mb4",
    class: _vm.isMobile ? '' : 'grid-half'
  }, [_c('ak-plan-card', {
    attrs: {
      "title": _vm.$t('planssettings.basic.plan1', {
        plan1: 'Phone Only'
      }),
      "subtitle": _vm.$t('planssettings.basic.plan2', {
        plan2: 'Protection'
      }),
      "description": _vm.$t('planssettings.basic.description', {
        description: 'Protect any phone against damage,<br> breakdowns, and theft'
      }),
      "price": "5-12",
      "buttonTitle": _vm.$t('planssettings.basic.select', {
        select: 'Protect Your Phone'
      }),
      "onClick": this.addPhoneOnlyPlan,
      "planData": this.phoneOnly
    }
  }), _vm._v(" "), _c('ak-plan-card', {
    attrs: {
      "title": _vm.$t('planssettings.advanced.plan1', {}),
      "subtitle": _vm.$t('planssettings.advanced.plan2', {
        plan2: 'The AKKO Plan'
      }),
      "description": _vm.$t('planssettings.advanced.description', {
        description: 'Protect 1 phone + all your electronic devices<br> and more (25 items total)'
      }),
      "descriptionStyles": "color-theme",
      "price": "15",
      "buttonTitle": _vm.$t('planssettings.advanced.select', {
        select: 'Protect Phone + 25 Items'
      }),
      "onClick": this.addAkkoPlan,
      "buttonPrimary": true,
      "planData": this.akkoPlan
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height flex items-center justify-between mb3"
  }, [_c('span', {
    staticClass: "f2 lh-copy pt3"
  }, [_vm._v("Add New Plan")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-409429f3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-409429f3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddPlan.vue
// module id = 1731
// module chunks = 0